/* globals _ */
const config = require("config");

(function () {
  "use strict";

  angular
    .module("fleetviewApp")
    .factory("complianceMapService", complianceMapService);

  function complianceMapService(ALKMaps, mapService, mapUtilities, $rootScope) {
    "ngInject";

    //ALKMaps.Renderer.symbol.flagshape = [-4, 0, -4, -5, 0, -5, 0, -2, -4, -2, -4, 0];
    ALKMaps.Renderer.symbol.check = [0, 0, 1, -1, 2, 0, 5, -3, 6, -2, 2, 2, 0, 0];
    ALKMaps.Renderer.symbol.ex = [0, 0, 2, -2, 0, -4, 1, -5, 3, -3, 5, -5, 6, -4, 4, -2, 6, 0, 5, 1, 3, -1, 1, 1, 0, 0];

    let complianceLayers = [];
    let eventSelect;

    let service = {
      initMap: initMap,
      clearMap: clearMap,
      drawRoute: drawRoute,
      redrawRoute: redrawRoute,
      selectRoute: selectRoute,
      setRouteVisibility: setRouteVisibility,
      setRoutePingsVisibility: setRoutePingsVisibility,
      frameRoute: frameRoute,
      frameAllRoutes: frameAllRoutes,
      zoomtoStop: zoomtoStop
    };
    return service;

    //Percent can be from -1 (shade to pure black) to 1 (shade to pure white). Negative number darkens, positive lightens
    function shadeColor(color, percent) {
      var f = parseInt(color.slice(1), 16),
        t = percent < 0 ? 0 : 255,
        p = percent < 0 ? percent * -1 : percent,
        R = f >> 16,
        G = f >> 8 & 0x00FF,
        B = f & 0x0000FF;
      return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
    }

    function initMap() {
      const mapObj = mapService.getMap();

      eventSelect = new ALKMaps.Control.FeatureEvent([], {
        featureAttributesFilter: [{
          property: "isMarker", //add route line as well
          value: true
        }]
      });

      mapObj.addControls([eventSelect]);
      eventSelect.activate();

    }

    function clearMap() {
      const mapObj = mapService.getMap();
      _.forEach(complianceLayers, (complianceObj) => {
        mapObj.removeLayer(complianceObj.plannedLayer);
        mapObj.removeLayer(complianceObj.actualLayer);
        complianceObj.oorLayer.removeAllFeatures();
        mapObj.removeLayer(complianceObj.oorLayer);
        complianceObj.stopLayer.removeAllFeatures();
        mapObj.removeLayer(complianceObj.stopLayer);
      });

      complianceLayers = [];
    }

    function redrawRoute(route) {
      const {
        origin,
        destination
      } = getConnectorLines(route);

      route.complianceObj.plannedLayer.destroyFeatures(route.complianceObj.plannedRouteFeature);
      route.complianceObj.plannedRouteFeature = getPlannedRouteFeature(route);
      // NOTE(boyler): adds the higher res planned line with the origin & destination connectors
      route.complianceObj.plannedLayer.addFeatures([origin, route.complianceObj.plannedRouteFeature, destination]);

      route.complianceObj.actualLayer.destroyFeatures(route.complianceObj.actualRouteFeatures);
      route.complianceObj.actualRouteFeatures = getActualRouteFeatures(route);
      route.complianceObj.actualLayer.addFeatures(route.complianceObj.actualRouteFeatures);

      route.complianceObj.plannedLayer.redraw();
      route.complianceObj.actualLayer.redraw();
    }

    function getPlannedRouteFeature(route) {
      return new ALKMaps.Feature.Vector(
        new ALKMaps.Geometry.LineString(route.plannedRoutePoints), {
        routeColor: route.routeColor
      }
      );
    }

    //Return multiple features in case we want to draw a line with an outline (AKA 2 lines), and also to draw the GPS pings
    function getActualRouteFeatures(route) {
      var features = [
        //The filled-in line that represents the actual route taken
        new ALKMaps.Feature.Vector(
          new ALKMaps.Geometry.LineString(route.actualRoutePoints),
          null, {
          //strokeWidth: 20,
          strokeColor: shadeColor(route.routeColor, -0.4), //Do not make this the regular routeColor - it needs to be visible when on top of the planned route and made distinct
          arrows: "line",
          arrowSize: "900%",
          arrowSpacing: 50,
          arrowStrokeColor: shadeColor(route.routeColor, -0.4),
          arrowFillColor: "#fff",
          arrowFillOpacity: 0.7,
          strokeOpacity: 0.8
        }
        ),
      ];
      //GPS Pings of actual route taken
      _.forEach(route.gpsPositions, (p) => {
        var ll = mapUtilities.LLtoMerc(p.Ln, p.Lt);
        var point = new ALKMaps.Geometry.Point(ll.lon, ll.lat);
        const pointFeature = new ALKMaps.Feature.Vector(
          point,
          null, {
          pointRadius: 2,
          fillColor: shadeColor(route.routeColor, -0.4),
          strokeWidth: 1,
          strokeColor: shadeColor(route.routeColor, -0.4)
        }
        );
        features.push(pointFeature);
      });
      return features;
    }

    function getConnectorLines(route) {

      const origin = new ALKMaps.Feature.Vector(
        new ALKMaps.Geometry.LineString(route.plannedConnectorPoints.origin), {
        routeColor: route.routeColor
      });

      const destination = new ALKMaps.Feature.Vector(
        new ALKMaps.Geometry.LineString(route.plannedConnectorPoints.destination), {
        routeColor: route.routeColor
      });

      return {
        origin,
        destination
      };

    }

    //TODO Function too big. Refactor to simplify and make smaller.
    function drawRoute(route) {
      const mapObj = mapService.getMap();

      const complianceObj = {};
      route.complianceObj = complianceObj;
      complianceObj.tripId = route.tripId;

      /* styles for prescribed route*/
      let routeStyle = new ALKMaps.Style({
        strokeColor: "${strokeColor}",
        strokeWidth: "${strokeWidth}",
        strokeOpacity: 0.7,
        strokeDashstyle: "line",
        graphicZIndex: 2
      }, {
        context: {
          strokeColor: function (feature) {
            return feature.attributes.routeColor;
          },
          strokeWidth: function (feature) {
            if (feature.layer.map.zoom >= 18) {
              return 35;
            } else if (feature.layer.map.zoom >= 16) {
              return 20;
            } else if (feature.layer.map.zoom >= 9) {
              return 10;
            } else {
              return 5;
            }
          }
        }
      });
      /*styles for origin and destination markers*/

      let markerStyle = new ALKMaps.Style({
        strokeColor: "${strokeColor}",
        strokeWidth: "${strokeWidth}",
        externalGraphic: "",
        fontWeight: "700",
        pointRadius: "${pointRadius}",
        fillColor: "#FFFFFF",
        fontColor: route.routeColor + "",
        fontSize: "${fontSize}",
        graphicZIndex: 100,
        label: "${label}"
      }, {
        context: {
          strokeColor: function (feature) {
            return feature.attributes.markerColor || feature.attributes.routeColor;
          },
          strokeWidth: function (feature) {
            if (feature.layer.map.zoom >= 17) {
              if (feature.attributes.label) {
                return 6;
              }
              return 10.5;
            } else {
              return feature.attributes.strokeWidth || 5.5;
            }
          },
          pointRadius: function (feature) {
            if (feature.layer.map.zoom >= 17) {
              return 12.5;
            } else {
              return feature.attributes.pointRadius;
            }
          },
          fontSize: function (feature) {
            if (feature.layer.map.zoom >= 17 && feature.attributes.label) {
              return 13;
            } else {
              return 10;
            }
          },
          label: function (feature) {
            return feature.attributes.label;
          }
        }
      });

      /* GPS points map styling */
      let pointsStyle = new ALKMaps.Style({
        externalGraphic: "${graphic}",
        graphicHeight: "${size}",
        graphicWidth: "${size}",
        graphicZIndex: 1000,
        rotation: "${rotation}"
      }, {
        context: {
          graphic: function (feature) {
            if (feature.attributes.heading) {
              return "/img/icons/gps_ping.svg";
            } else {
              return "/img/icons/gps_ping_nohd.svg";
            }
          },
          size: function (feature) {
            if (feature.layer.map.zoom >= 17) {

              return 26;
            } else if (feature.layer.map.zoom >= 13) {
              return 24;
            } else if (feature.layer.map.zoom >= 11) {
              return 18;
            } else {
              return 10;
            }
          },
          rotation: function (feature) {
            var heading = parseInt(feature.attributes.heading);
            return heading;
          }
        }
      });

      let routeStyleMap = new ALKMaps.StyleMap({
        default: routeStyle,
        select: routeStyle
      });

      let markerStyleMap = new ALKMaps.StyleMap({
        default: markerStyle,
        select: markerStyle
      });
      let pointsStyleMap = new ALKMaps.StyleMap({
        default: pointsStyle,
        select: pointsStyle
      });


      complianceObj.plannedLayer = new ALKMaps.Layer.VectorMarkers("Planned Layer " + route.tripId, {
        styleMap: routeStyleMap
      });
      complianceObj.actualLayer = new ALKMaps.Layer.Vector("Actual Layer " + route.tripId);
      complianceObj.oorLayer = new ALKMaps.Layer.VectorMarkers("OOR Layer " + route.tripId, {
        styleMap: pointsStyleMap
      });

      complianceObj.stopLayer = new ALKMaps.Layer.VectorMarkers("Stop Layer " + route.tripId, {
        styleMap: markerStyleMap
      });

      mapObj.addLayers([complianceObj.plannedLayer, complianceObj.actualLayer, complianceObj.oorLayer, complianceObj.stopLayer]);

      complianceObj.plannedRouteFeature = getPlannedRouteFeature(route);
      complianceObj.plannedLayer.addFeatures(complianceObj.plannedRouteFeature);
      complianceObj.actualRouteFeatures = getActualRouteFeatures(route);

      complianceObj.actualLayer.addFeatures(complianceObj.actualRouteFeatures);

      _.forEach(route.gpsPositions, (p, i) => {
        var lonlat, dir, heading;
        let pingContent = "<div class='oor-popup'>";

        if (p.Lt) {
          lonlat = new ALKMaps.LonLat(p.Ln, p.Lt).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
          dir = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
          heading = dir[Math.floor((p.H / 22.5) + .5) % 16];
          pingContent += `<strong> GPS Ping: ${i} </strong> <br/>`;
          pingContent += `<strong>Coordinates: </strong>${p.Lt}, ${p.Ln}`;
          pingContent += (p.timeStamp && p.timeStamp !== "--" && p.timeStamp.length !== 0) ? `<br/> <strong>Time:</strong> ${p.timeStamp}` : "<br/> <strong>Time:</strong> Date Unavailable";
          pingContent += p.S ? ` <br/> <strong>Speed:</strong> ${p.S} mph ` : "";
          pingContent += p.H ? ` <br/> <strong>Direction:</strong> ${heading} (${p.H}°)` : "";
          pingContent += p.Al ? `  <br/><strong>Altitude:</strong> ${p.Al} m` : "";
        } else {
          lonlat = new ALKMaps.LonLat(p[0], p[1]).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
          pingContent += "<strong> GPS Ping: </strong> <br/>";
          pingContent += `<strong>Coordinates: </strong>${p[0]}, ${p[1]}</br>`
        }

        pingContent += "</div>";
        let pingMarker = complianceObj.oorLayer.createMarker(
          lonlat.clone(), {
          popupSize: new ALKMaps.Size(225, 60),
          popupContentHTML: pingContent,
          anchor: {
            size: new ALKMaps.Size(1, 1),
            //offset: new ALKMaps.Pixel(-3, -25)
          },
          overflow: "auto",
          markerType: "custom",
          routeColor: route.routeColor + "",
          speed: p.S,
          heading: p.H
        });
        pingMarker.createPopup(true); //close button argument
      });

      _.forEach(route.outOfRouteEvents, (e) => {

        let dir = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
        let heading = dir[Math.floor((e.oorHeading / 22.5) + .5) % 16];
        let popupContent = "<div class='oor-popup'>";

        popupContent += `<strong> ${e.type} </strong><br>
        <strong> Coordinates: </strong> ${e.oorLat}, ${e.oorLon}<br>
        <strong> Time: </strong> ${e.timeStamp} `
        popupContent += e.type === "Left Route" ? "" : ` <br><strong>OOR:</strong> ${e.distanceOOR} mi`;
        popupContent += e.oorSpeed ? `  <br/><strong>Speed:</strong> ${e.oorSpeed} mph ` : "";
        popupContent += e.oorHeading ? ` <br/><strong> Direction: </strong> ${heading} (${e.oorHeading}°)` : "";
        popupContent += e.oorAltitude ? ` <br/> <strong> Altitude: </strong> ${e.oorAltitude} m ` : "";
        popupContent += "</div>";

        let graphic = "";
        if (e.type === "Left Route") {
          graphic = e.oorHeading ? "/img/icons/gps_ping_exit.svg" : "/img/icons/gps_ping_exit_nohd.svg"
        } else {
          graphic = e.oorHeading ? "/img/icons/gps_ping_return.svg" : "/img/icons/gps_ping_return_nohd.svg"
        }

        let oorPing = complianceObj.oorLayer.createMarker(
          e.lonlat.clone(), {
          popupSize: new ALKMaps.Size(225, 60),
          popupContentHTML: popupContent,
          anchor: {
            size: new ALKMaps.Size(1, 1),
            //offset: new ALKMaps.Pixel(-3, -25)
          },
          overflow: "auto"
        }, {
          externalGraphic: graphic,
          pointRadius: "12",
          rotation: e.oorHeading
        });
        oorPing.createPopup(true); //close button argument

      });

      let stopContent = {};
      let stopMarker = {};
      for (let i = 1; i <= route.stopCount; i++) {
        stopContent[i] = "<div class='oor-popup'>";
        stopContent[i] += `<strong> Stop: </strong>  (${route.stops[i].stopNumber}) <br/>`;
        if (route.stops[i].stopName) {
          stopContent[i] += `<br/> <strong> ${route.stops[i].stopName} </strong>`;
        }
        stopContent[i] += `<strong> Address: </strong>`
        stopContent[i] += ` ${route.stops[i].stopStreet},`;
        stopContent[i] += route.stops[i].stopCity + ", " + route.stops[i].stopState + " " + route.stops[i].stopZip + "<br/>";
        stopContent[i] += `<strong>Coordinates: </strong> ${route.stops[i].stopCoords} <br/>`;

        stopContent[i] += "</div>";
        stopMarker[i] = complianceObj.stopLayer.createMarker(
          route.stops[i].stoplonLat.clone(), {
          popupSize: new ALKMaps.Size(225, 60),
          popupContentHTML: stopContent[i],
          anchor: {
            size: new ALKMaps.Size(1, 1),
          },
          overflow: "auto",
          markerType: "custom",
          label: route.stops[i].stopNumber,
          routeColor: route.routeColor + "",
          pointRadius: "8",
          strokeWidth: 2
        }
        );
        stopMarker[i].createPopup(true); //close button argument
      }

      if (route.originLonLat) {
        let originContent = "<div class='oor-popup'>";
        originContent += ` <strong> Origin:</strong>`;
        if (route.originStopName) {
          originContent += `<strong> ${route.originStopName}</strong> <br/>`;
        }
        originContent += `<strong> Address: </strong>`
        originContent += route.originStreet + ",";
        originContent += route.originCity + ", " + route.originState + " " + route.originZip + "<br/>";
        originContent += `<strong>Coordinates: </strong> ${route.originCoords} <br/>`;
        originContent += `<strong>Time: </strong> ${route.originTime}`;
        originContent += "</div>";

        let originMarker = complianceObj.stopLayer.createMarker(
          route.originLonLat.clone(), {
          popupSize: new ALKMaps.Size(225, 60),
          popupContentHTML: originContent,
          anchor: {
            size: new ALKMaps.Size(1, 1)
          },
          overflow: "auto",
          markerType: "custom",
          markerColor: "#279E00",
          pointRadius: "6.5",
          label: ""
        });

        originMarker.createPopup(true); //close button argument
      }

      if (route.destinationLonLat) {
        let destinationContent = "<div class='oor-popup'>";
        destinationContent += "<strong>Destination: </strong>";
        if (route.destinationStopName) {
          destinationContent += ` <strong> ${route.destinationStopName} </strong>`;
        }
        destinationContent += ` <br/><strong> Address: </strong>`
        destinationContent += route.destinationStreet + ",";
        destinationContent += route.destinationCity + ", " + route.destinationState + " " + route.destinationZip + "<br/>";
        destinationContent += `<strong>Coordinates: </strong> ${route.destinationCoords} <br/>`;
        destinationContent += `<strong>Time: </strong> ${route.destinationTime}`;

        destinationContent += "</div>";

        let destinationMarker = complianceObj.stopLayer.createMarker(
          route.destinationLonLat.clone(), {
          popupSize: new ALKMaps.Size(225, 60),
          popupContentHTML: destinationContent,
          anchor: {
            size: new ALKMaps.Size(1, 1),
            //offset: new ALKMaps.Pixel(-3, -25)
          },
          overflow: "auto",
          markerType: "custom",
          markerColor: "#be2525",
          pointRadius: "6.5",
          label: ""
        });

        destinationMarker.createPopup(true);
      }
      complianceObj.actualLayer.setVisibility(false);
      complianceObj.oorLayer.setVisibility(false);

      complianceObj.oorLayer.events.register("featureclicked", this, clickHandler);
      complianceObj.oorLayer.events.register("featureclickedout", this, outHandler);

      complianceObj.stopLayer.events.register("featureclicked", this, clickHandler);
      complianceObj.stopLayer.events.register("featureclickedout", this, outHandler);

      complianceLayers.push(complianceObj);

      eventSelect.setLayer(
        _.flatten(
          _.map(complianceLayers, (co) => {
            return [co.oorLayer, co.stopLayer];
          })
        ));
    }

    function clickHandler(event) {
      let mapObj = mapService.getMap();
      mapObj.addPopup(event.feature.popup, true);
      event.feature.popup.show();
    }

    function outHandler(event) {
      //Removing the popup (as opposed to just hiding it) stops the popup from sometimes blinking in and out repeatedly
      let mapObj = mapService.getMap();
      mapObj.removePopup(event.feature.popup);
    }

    function selectRoute(tripId, isVisible) {
      let mapObj = mapService.getMap();
      _.forEach(complianceLayers, (complianceObj) => {
        eventSelect.deactivate();

        complianceObj.plannedLayer.setOpacity(0.4);
        complianceObj.actualLayer.setVisibility(false);
        complianceObj.oorLayer.setVisibility(false);
        setStopLayerOpacity(complianceObj.stopLayer, 0.4);
        complianceObj.stopLayer.setZIndex(100);
        complianceObj.stopLayer.refresh();
        complianceObj.plannedLayer.refresh();
        eventSelect.activate();
        if (mapObj.popups.length) {
          mapObj.removePopup(mapObj.popups[0]);
        }
      });
      let selectedRoute = _.find(complianceLayers, {
        tripId: tripId
      });
      selectedRoute.select = true;

      if (selectedRoute && isVisible) {
        selectedRoute.plannedLayer.setOpacity(0.8);
        selectedRoute.actualLayer.setVisibility(true);
        setStopLayerOpacity(selectedRoute.stopLayer, 1);
        selectedRoute.stopLayer.refresh();
        selectedRoute.plannedLayer.setZIndex(500);
        selectedRoute.actualLayer.setZIndex(500);
        selectedRoute.stopLayer.setZIndex(610);
      }

    }

    function setRouteVisibility(tripId, isVisible) {
      let mapObj = mapService.getMap();
      let theRoute = _.find(complianceLayers, {
        tripId: tripId
      });
      if (theRoute) {
        theRoute.plannedLayer.setVisibility(isVisible);
        theRoute.stopLayer.setVisibility(isVisible);

        if (!isVisible) {
          theRoute.actualLayer.setVisibility(false);
          theRoute.oorLayer.setVisibility(false);
        }
        if (isVisible) {
          selectRoute(tripId, isVisible);
        }
      }
      if (mapObj.popups.length) {
        mapObj.removePopup(mapObj.popups[0]);
      }

    }

    function setRoutePingsVisibility(tripId, isVisible) {
      let mapObj = mapService.getMap();
      let theRoute = _.find(complianceLayers, {
        tripId: tripId
      });

      if (theRoute && isVisible) {
        theRoute.oorLayer.setVisibility(true);
        theRoute.oorLayer.setZIndex(600);
      }

      if (theRoute && !isVisible) {
        theRoute.oorLayer.setVisibility(false);
        theRoute.oorLayer.setZIndex(0);
      }
      if (mapObj.popups.length) {
        mapObj.removePopup(mapObj.popups[0]);
      }
    }

    function frameRoute(tripId) {
      let mapObj = mapService.getMap();

      mapObj.updateSize();

      let route = _.find(complianceLayers, {
        tripId: tripId
      });

      if (route) {
        var dataExtent = route.plannedLayer.getDataExtent();
        var actualLayer = route.actualLayer.getDataExtent();
        dataExtent.extend(actualLayer);
        if (!_.isEmpty(dataExtent)) {
          mapObj.zoomToExtent(dataExtent, false);
        }
      }
    }

    function zoomtoStop(latlong) {
      let mapObj = mapService.getMap();
      mapObj.setCenter(latlong);
      mapObj.zoomTo(16);
    }

    function frameAllRoutes() {
      let mapObj = mapService.getMap();

      mapObj.updateSize();

      let e = new ALKMaps.Bounds();

      _.forEach(complianceLayers, (complianceObj) => {
        e.extend(complianceObj.plannedLayer.getDataExtent());
        complianceObj.plannedLayer.setOpacity(1);
        setStopLayerOpacity(complianceObj.stopLayer, 0.8);
      });

      if (e.left !== null) {
        mapObj.zoomToExtent(e, false);
      }
      if (mapObj.popups.length) {
        mapObj.removePopup(mapObj.popups[0]);
      }
    }

    //When setting the opacity of a layer with select control we must disable that control before setting opacity and re-activate after
    function setStopLayerOpacity(stopLayer, opacity) {
      eventSelect.deactivate();
      stopLayer.setOpacity(opacity);
      eventSelect.activate();
    }
  }
})();



// WEBPACK FOOTER //
// ./app/compliance/complianceMap.service.js